module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [(_vm.canAccess('series-view-any')) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Series Master")]), _vm._v(" "), _c('span', {
    staticClass: "pull-center"
  }, [(_vm.canAccess('series-update')) ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editModal(_vm.series)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "table table-responsive table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Member Prefix")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.memberPrefix))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Member Series")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.memberSeries))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Branch Code Inclusion")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.series.memberIncludeBranchCode == 'true'),
      expression: "series.memberIncludeBranchCode == 'true'"
    }]
  }, [_c('span', {
    staticClass: "text-success"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.series.memberIncludeBranchCode == 'false'),
      expression: "series.memberIncludeBranchCode == 'false'"
    }]
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("No")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('table', {
    staticClass: "table table-responsive table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Employee/Agent Prefix")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.agentPrefix))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Employee/Agent Series")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.agentSeries))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Branch Code Inclusion")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.series.agentIncludeBranchCode == 'true'),
      expression: "series.agentIncludeBranchCode == 'true'"
    }]
  }, [_c('span', {
    staticClass: "text-success"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.series.agentIncludeBranchCode == 'false'),
      expression: "series.agentIncludeBranchCode == 'false'"
    }]
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("No")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Application Series")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.applicationSeries))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Branch Code Inclusion")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.series.applicationIncludeBranchCode == 'true'),
      expression: "series.applicationIncludeBranchCode == 'true'"
    }]
  }, [_c('span', {
    staticClass: "text-success"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.series.applicationIncludeBranchCode == 'false'),
      expression: "series.applicationIncludeBranchCode == 'false'"
    }]
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("No")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(4), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Branch Prefix")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.branchPrefix))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Branch Series")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.branchSeries))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(5), _vm._v(" "), _c('table', {
    staticClass: "table table-responsive table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Collection Center Prefix")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.collectionCenterPrefix))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Collection Center Series")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.collectionCenterSeries))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Financial Year Inclusion")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.series.collectionCenterIncludeYear == 'true'),
      expression: "series.collectionCenterIncludeYear == 'true'"
    }]
  }, [_c('span', {
    staticClass: "text-success"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.series.collectionCenterIncludeYear == 'false'),
      expression: "series.collectionCenterIncludeYear == 'false'"
    }]
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("No")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(6), _vm._v(" "), _c('table', {
    staticClass: "table table-responsive table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Application Form Prefix")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.memberApplicationFormNoPrefix))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Application Form Series")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.memberApplicationFormNoSeries))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Financial Year Inclusion")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.series.memberApplicationFormNoIncludeYear == 'true'),
      expression: "series.memberApplicationFormNoIncludeYear == 'true'"
    }]
  }, [_c('span', {
    staticClass: "text-success"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.series.memberApplicationFormNoIncludeYear == 'false'),
      expression: "series.memberApplicationFormNoIncludeYear == 'false'"
    }]
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("No")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(7), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Branch Center Prefix")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.branchCenterPrefix))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Branch Center Series")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.branchCenterSeries))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_vm._v("\r\n          List of Series\r\n        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "newModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(8), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateSeries()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', [_vm._v("Member Series Update")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberPrefix),
      expression: "form.memberPrefix"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('memberPrefix'),
    },
    attrs: {
      "type": "text",
      "name": "memberPrefix"
    },
    domProps: {
      "value": (_vm.form.memberPrefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "memberPrefix", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "memberPrefix"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberSeries),
      expression: "form.memberSeries"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('memberSeries'),
    },
    attrs: {
      "type": "text",
      "name": "memberSeries"
    },
    domProps: {
      "value": (_vm.form.memberSeries)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "memberSeries", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "memberSeries"
    }
  })], 1), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberIncludeBranchCode),
      expression: "form.memberIncludeBranchCode"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "memberIncludeBranchCode",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.memberIncludeBranchCode, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "memberIncludeBranchCode", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Yes")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "memberIncludeBranchCode"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberIncludeBranchCode),
      expression: "form.memberIncludeBranchCode"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "memberIncludeBranchCode",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.memberIncludeBranchCode, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "memberIncludeBranchCode", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("No")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "memberIncludeBranchCode"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', [_vm._v("Employee Series Update")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.agentPrefix),
      expression: "form.agentPrefix"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('agentPrefix')
    },
    attrs: {
      "type": "text",
      "name": "agentPrefix"
    },
    domProps: {
      "value": (_vm.form.agentPrefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "agentPrefix", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agentPrefix"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.agentSeries),
      expression: "form.agentSeries"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('agentSeries'),
    },
    attrs: {
      "type": "text",
      "name": "agentSeries"
    },
    domProps: {
      "value": (_vm.form.agentSeries)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "agentSeries", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agentSeries"
    }
  })], 1), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.agentIncludeBranchCode),
      expression: "form.agentIncludeBranchCode"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "agentIncludeBranchCode",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.agentIncludeBranchCode, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "agentIncludeBranchCode", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Yes")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agentIncludeBranchCode"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.agentIncludeBranchCode),
      expression: "form.agentIncludeBranchCode"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "agentIncludeBranchCode",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.agentIncludeBranchCode, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "agentIncludeBranchCode", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("No")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agentIncludeBranchCode"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', [_vm._v("Application Series Update")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(15), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.applicationSeries),
      expression: "form.applicationSeries"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('applicationSeries'),
    },
    attrs: {
      "type": "text",
      "name": "applicationSeries"
    },
    domProps: {
      "value": (_vm.form.applicationSeries)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "applicationSeries", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "applicationSeries"
    }
  })], 1), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.applicationIncludeBranchCode),
      expression: "form.applicationIncludeBranchCode"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "applicationIncludeBranchCode",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.applicationIncludeBranchCode, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "applicationIncludeBranchCode", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Yes")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "applicationIncludeBranchCode"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.applicationIncludeBranchCode),
      expression: "form.applicationIncludeBranchCode"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "applicationIncludeBranchCode",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.applicationIncludeBranchCode, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "applicationIncludeBranchCode", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("No")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "applicationIncludeBranchCode"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', [_vm._v("Branch Series Update")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branchPrefix),
      expression: "form.branchPrefix"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branchPrefix'),
    },
    attrs: {
      "type": "text",
      "name": "branchPrefix"
    },
    domProps: {
      "value": (_vm.form.branchPrefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "branchPrefix", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branchPrefix"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(18), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branchSeries),
      expression: "form.branchSeries"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branchSeries'),
    },
    attrs: {
      "type": "text",
      "name": "branchSeries"
    },
    domProps: {
      "value": (_vm.form.branchSeries)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "branchSeries", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branchSeries"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', [_vm._v("Collection Center Series Update")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(19), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.collectionCenterPrefix),
      expression: "form.collectionCenterPrefix"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('collectionCenterPrefix'),
    },
    attrs: {
      "type": "text",
      "name": "collectionCenterPrefix"
    },
    domProps: {
      "value": (_vm.form.collectionCenterPrefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "collectionCenterPrefix", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "collectionCenterPrefix"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.collectionCenterSeries),
      expression: "form.collectionCenterSeries"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('collectionCenterSeries'),
    },
    attrs: {
      "type": "text",
      "name": "collectionCenterSeries"
    },
    domProps: {
      "value": (_vm.form.collectionCenterSeries)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "collectionCenterSeries", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "collectionCenterSeries"
    }
  })], 1), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.collectionCenterIncludeYear),
      expression: "form.collectionCenterIncludeYear"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "collectionCenterIncludeYear",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.collectionCenterIncludeYear, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "collectionCenterIncludeYear", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Yes")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "collectionCenterIncludeYear"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.collectionCenterIncludeYear),
      expression: "form.collectionCenterIncludeYear"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "collectionCenterIncludeYear",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.collectionCenterIncludeYear, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "collectionCenterIncludeYear", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("No")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "collectionCenterIncludeYear"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', [_vm._v("Member Application Form Series Update")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(22), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberApplicationFormNoPrefix),
      expression: "form.memberApplicationFormNoPrefix"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('memberApplicationFormNoPrefix'),
    },
    attrs: {
      "type": "text",
      "name": "memberApplicationFormNoPrefix"
    },
    domProps: {
      "value": (_vm.form.memberApplicationFormNoPrefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "memberApplicationFormNoPrefix", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "memberApplicationFormNoPrefix"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(23), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberApplicationFormNoSeries),
      expression: "form.memberApplicationFormNoSeries"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('memberApplicationFormNoSeries'),
    },
    attrs: {
      "type": "text",
      "name": "memberApplicationFormNoSeries"
    },
    domProps: {
      "value": (_vm.form.memberApplicationFormNoSeries)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "memberApplicationFormNoSeries", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "memberApplicationFormNoSeries"
    }
  })], 1), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberApplicationFormNoIncludeYear),
      expression: "form.memberApplicationFormNoIncludeYear"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "memberApplicationFormNoIncludeYear",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.memberApplicationFormNoIncludeYear, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "memberApplicationFormNoIncludeYear", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Yes")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "memberApplicationFormNoIncludeYear"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberApplicationFormNoIncludeYear),
      expression: "form.memberApplicationFormNoIncludeYear"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "memberApplicationFormNoIncludeYear",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.memberApplicationFormNoIncludeYear, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "memberApplicationFormNoIncludeYear", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("No")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "memberApplicationFormNoIncludeYear"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', [_vm._v("Branch Center Series Update")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(25), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branchCenterPrefix),
      expression: "form.branchCenterPrefix"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branchCenterPrefix'),
    },
    attrs: {
      "type": "text",
      "name": "branchCenterPrefix"
    },
    domProps: {
      "value": (_vm.form.branchCenterPrefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "branchCenterPrefix", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branchCenterPrefix"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(26), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branchCenterSeries),
      expression: "form.branchCenterSeries"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branchCenterSeries'),
    },
    attrs: {
      "type": "text",
      "name": "branchCenterSeries"
    },
    domProps: {
      "value": (_vm.form.branchCenterSeries)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "branchCenterSeries", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branchCenterSeries"
    }
  })], 1)])])])])]), _vm._v(" "), _vm._m(27)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "",
      "data-original-title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "",
      "data-original-title": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Member Series")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Employee/Agent Series")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Application Series")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Branch Series")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Collection Center Series")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Application Form Series")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Branch Center Series")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Master Series Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Member Prefix "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Member Series "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Branch Code Inclusion ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Employee Prefix "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Employee Series "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Branch Code Inclusion ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Application Series "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Branch Code Inclusion ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch Prefix "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch Series "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Collection Center Prefix "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Collection Center Series "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Financial Year Inclusion ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Application Form Prefix "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Application Form Series "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Financial Year Inclusion ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch Center Prefix "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch Center Series "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("UPDATE")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("CANCEL")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b116c08!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/master/SeriesMaster.vue
// module id = 823
// module chunks = 0